import { UNKNOWN_LIBRARY } from '@/core/const/installation.const'
import type { GcgNames, GcgNamingInput } from '@/core/types/installation.type'

import { buildGraftConfigEnvVarName } from '../buildGraftConfigEnvVarName'

import {
  buildGraftName,
  buildMavenGroupId,
  buildPackageNamespace,
  buildPhpNamespace,
  buildPublishId,
  buildRubyRequirePath,
  getSourceRepository,
} from './builders'
import { normalizeNameForNamespace } from './normalizeNameForNamespace'
import { normalizePythonModule } from './normalizePythonModule'

export const buildGcgNames = (input: GcgNamingInput): GcgNames => {
  const repository = getSourceRepository(input.sourceRuntime)
  const libraryName = input.libraryName?.trim() ? input.libraryName : UNKNOWN_LIBRARY
  const normalizedLibraryName = normalizeNameForNamespace(libraryName)
  const pythonModule = normalizePythonModule(libraryName)
  const packageNamespace = buildPackageNamespace(
    input.consumerTechnology,
    repository,
    libraryName,
    normalizedLibraryName
  )
  const publishId = buildPublishId(
    input.consumerTechnology,
    repository,
    libraryName,
    input.libraryNamespace,
    packageNamespace,
    normalizedLibraryName
  )
  const graftName = buildGraftName(
    input.consumerTechnology,
    repository,
    libraryName,
    packageNamespace,
    input.libraryNamespace
  )
  const graftConfigEnvVarName = buildGraftConfigEnvVarName(input.sourceRuntime, libraryName, input.libraryNamespace)
  const mavenGroupId = buildMavenGroupId(input.libraryNamespace)
  const phpNamespace = buildPhpNamespace(repository, libraryName)
  const rubyRequirePath = buildRubyRequirePath(repository, libraryName)

  return {
    repository,
    libraryName,
    normalizedLibraryName,
    packageNamespace,
    graftName,
    graftConfigEnvVarName,
    publishId,
    mavenGroupId,
    mavenArtifactId: libraryName,
    phpNamespace,
    rubyRequirePath,
    pythonModule,
  }
}
